import {useEffect, useRef} from "react";
import {createRequestRefreshScheduler} from "./requestRefreshScheduler";

const useRequestRefreshScheduler = (request, {delay = 1000, onError, debounce = true} = {}) => {
    const requestRef = useRef(request);
    const onErrorRef = useRef(onError);
    requestRef.current = request;
    onErrorRef.current = onError;

    const schedulerRef = useRef();
    const ensureScheduler = () => {
        schedulerRef.current ||= createRequestRefreshScheduler({
            request: () => requestRef.current(),
            onError: error => onErrorRef.current?.(error),
            delay,
            debounce,
        });
        return schedulerRef.current;
    };

    const facadeRef = useRef();
    facadeRef.current ||= {
        schedule: callback => ensureScheduler().schedule(callback),
    };

    useEffect(() => {
        const scheduler = ensureScheduler();
        return () => {
            scheduler.dispose();
            if(schedulerRef.current === scheduler) schedulerRef.current = undefined;
        };
    }, []);

    return facadeRef.current;
};

export default useRequestRefreshScheduler;
